import styled from "styled-components"

export const StyledMcpUsers = styled.div`
  .tab-toolbar {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-bottom: 12px;
  }

  .table-container {
    margin-top: 20px;
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    background: var(--cms-surface-secondary, #fff);
    color: var(--cms-text-primary, #0f172a);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;

    thead {
      background-color: var(--cms-surface-muted, #f5f5f5);
      border-bottom: 2px solid var(--cms-border, #ddd);
    }

    th {
      padding: 12px;
      text-align: left;
      font-weight: 600;
      color: var(--cms-text-primary, #0f172a);
      white-space: nowrap;
    }

    td {
      padding: 12px;
      color: var(--cms-text-primary, #0f172a);
      border-bottom: 1px solid var(--cms-border, #eee);
    }

    tbody tr {
      transition: background-color 0.2s;

      &:hover {
        background-color: var(--cms-surface-muted, #f9f9f9);
      }

      &.revoked {
        opacity: 0.6;
        background-color: var(--cms-surface-muted, #fff5f5);
      }
    }
  }

  .status-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;

    &.active {
      background-color: var(--cms-success-bg);
      color: #166534 !important;
    }

    &.revoked {
      background-color: var(--cms-error-bg);
      color: #9f1239 !important;
    }
  }

  .mcp-user-id {
    font-family: monospace;
    font-size: 12px;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .actions-cell {
    display: flex;
    gap: 8px;

    button {
      padding: 4px 8px;
      font-size: 12px;
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px;
    color: var(--cms-text-secondary, #475569);
    background: var(--cms-surface-secondary, #fff);
    border-radius: 4px;
  }

  .form-group {
    margin-bottom: 20px;

    label {
      display: block;
      margin-bottom: 8px;
      font-weight: 600;
      color: var(--cms-text-primary);
    }

    input,
    select {
      width: 100%;
      padding: 10px;
      border: 1px solid var(--cms-border);
      border-radius: 4px;
      font-size: 14px;
      color: var(--cms-text-primary);
      background: var(--cms-input-bg);

      &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
      }

      &:disabled {
        background-color: var(--cms-surface-muted);
        color: var(--cms-text-secondary);
        cursor: not-allowed;
      }
    }

    .required {
      color: red;
    }
  }

  .error-message {
    padding: 12px;
    background-color: var(--cms-error-bg);
    color: #9f1239;
    border: 1px solid rgba(239, 68, 68, 0.35);
    border-radius: 4px;
    margin-bottom: 15px;
  }

  .success-message {
    padding: 12px;
    background-color: var(--cms-success-bg);
    color: #166534;
    border: 1px solid rgba(34, 197, 94, 0.35);
    border-radius: 4px;
    margin-bottom: 15px;
  }

  [data-cms-theme="dark"] & {
    .status-badge.active,
    .success-message {
      color: #86efac !important;
    }

    .status-badge.revoked,
    .error-message {
      color: #fda4af !important;
    }
  }
`
